import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { AdminShell, adminPage } from '#/components/admin/admin-shell'
import { PlanDrawer } from '#/components/admin/plan-drawer'
import { DataTable, Pager, SearchBox, fmtUsd } from '#/components/admin/ui'
import { Badge } from '#/components/ui/badge'
import { useAdminPlans, type AdminPlanRow } from '#/lib/api-admin'
import { fmtDate } from '#/lib/format'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/admin/plans')({ component: adminPage(Page) })

function Page() {
  const [q, setQ] = useState('')
  const [page, setPage] = useState(1)
  const [sel, setSel] = useState<string | null>(null)
  const { data, isLoading, isError, isFetching, refetch } = useAdminPlans(q, page)
  return (
    <AdminShell title={m.admin_nav_plans()} actions={<SearchBox value={q} onChange={(v) => { setQ(v); setPage(1) }} placeholder={m.admin_plans_search()} />}>
      <DataTable<AdminPlanRow>
        rows={data?.plans}
        loading={isLoading} error={isError} retrying={isFetching} onRetry={refetch}
        rowKey={(p) => p.id}
        onRow={(p) => setSel(p.id)}
        cols={[
          { key: 'title', header: m.admin_col_title(), render: (p) => <div><div className="font-medium">{p.title}</div><div className="text-xs text-muted-foreground">{p.workspaceName}</div></div> },
          { key: 'user', header: m.admin_col_email(), render: (p) => p.userEmail },
          { key: 'status', header: m.admin_col_status(), render: (p) => <Badge variant="secondary">{p.status}</Badge> },
          { key: 'step', header: m.admin_col_step(), render: (p) => p.step, className: 'text-right tabular-nums' },
          { key: 'cost', header: m.admin_col_cost(), render: (p) => fmtUsd(p.costUsd), className: 'text-right tabular-nums' },
          { key: 'created', header: m.admin_col_created(), render: (p) => fmtDate(p.createdAt) },
        ]}
      />
      {data ? <Pager page={data.page} total={data.total} pageSize={data.pageSize} onPage={setPage} /> : null}
      <PlanDrawer planId={sel} onClose={() => setSel(null)} />
    </AdminShell>
  )
}
